<template>

    <div class="bodyComponente">
        <div class="cardsWrapper">
            <card-status texto-header="Infraestrutura UCG" :texto-card="statusMessageLocation"
                :is-erro="locationCheck.statusCode !== 200"
                 @click.native="$router.push('/infraestrutura-ucg')" />
            <card-status texto-header="Infraestrutura MMI" :texto-card="statusMessageSystem"
                :is-erro="systemCheck.statusCode !== 200"
                @click.native="$router.push('/infraestrutura-mmi')" />
            <card-status texto-header="Módulos MMI" :texto-card="statusMessageTimestamp"
                :is-erro="timestampCheck.offline && timestampCheck.offline.length > 0"
                @click.native="$router.push('/modulos')" />
            <card-status texto-header="Máquinas" :texto-card="statusMessageMachine"
                :is-erro="machineCheck.statusCode !== 200"
               @click.native="$router.push('/machines')"/>
            <card-status texto-header="Planilha Diária" :texto-card="statusMessageSpreadsheet"
                :is-erro="spreadsheetCheck.statusCode !== 200" />
        </div>
    </div>

</template>


<script>
	import CardStatus from "../components/CardStatus.vue";
	import { FetchLocationDashboard } from "../services/location";
	import { FetchSystemDashboard } from "../services/system";
	import { FetchSpreadsheetDashboard } from "../services/spreadsheet";
	import { FetchTimestampDashboard } from "../services/modules";
	import { FetchMachineDashboard } from "../services/machine";

	export default {
		name: "DashboardPage",
		components: {
			CardStatus
		},
		data () {
			return {
				locationCheck: { statusCode: 418, problems: [] },
				systemCheck: { statusCode: 418, problems: [] },
				spreadsheetCheck: { statusCode: 418, message: "" },
				timestampCheck: { statusCode: 418, online: [], offline: [] },
				machineCheck: { statusCode: 418, problems: [] },
				refresh: null
			};
		},
		computed: {
			statusMessageLocation () {
				if (this.locationCheck.statusCode === 200) return "Online";
				return (this.locationCheck.problems.length > 0)
					? this.locationCheck.problems.join("\n ")
					: "Erro Desconhecido";
			},
			statusMessageSystem () {
				if (this.systemCheck.statusCode === 200) return "Online";
				return (this.systemCheck.problems.length > 0)
					? this.systemCheck.problems.join("\n")
					: "Erro Desconhecido";
			},
			statusMessageSpreadsheet () {
				if (this.spreadsheetCheck.statusCode === 200) return "Online";
				return this.spreadsheetCheck.message;
			},

			statusMessageTimestamp () {
				if (this.timestampCheck.offline?.length > 0) {
					return `Módulos offline: 
						${this.timestampCheck.offline.map(m => m.service).join(", ")}`;
				}

				if (this.timestampCheck.online?.length > 0) {
					return "Todos os módulos online";
				}

				return "Erro ao verificar módulos";
			},

			statusMessageTimestampFooter () {
				if (this.timestampCheck.offline?.length > 0) {
					return this.timestampCheck.offline.map(m => m.service).join(", ");
				}
				return "";
			},

			statusMessageMachine () {
				if (this.machineCheck.statusCode === 200) return "Online";
				return (this.machineCheck.problems.length > 0)
					? this.machineCheck.problems.join("\n ")
					: "Erro Desconhecido";
			}

		},
		methods: {

			async locationDashboard () {
				const data = await FetchLocationDashboard();
				this.locationCheck = data;
			},
			async systemDashboard () {
				const data = await FetchSystemDashboard();
				this.systemCheck = data;
			},
			async spreadsheetDashboard () {
				const data = await FetchSpreadsheetDashboard();
				this.spreadsheetCheck = data;
			},
			async timestampDashboard () {
				const data = await FetchTimestampDashboard();
				this.timestampCheck = data;
			},

			async machineDashboard () {
				const data = await FetchMachineDashboard();
				this.machineCheck = data;
			}

		},
		mounted () {
			this.locationDashboard();
			this.systemDashboard();
			this.spreadsheetDashboard();
			this.timestampDashboard();
			this.machineDashboard();

			this.refresh = setInterval(() => {
				this.locationDashboard();
				this.systemDashboard();
				this.spreadsheetDashboard();
				this.timestampDashboard();
				this.machineDashboard();
			}, 30000);
		},
		beforeDestroy () {
			clearInterval(this.refresh);
		}
	};
</script>


<style scoped>
.bodyComponente {
    width: calc(100% - 70px);
    margin-left: 70px;
    padding: 6rem 2rem;
    box-sizing: border-box;
}

.cardsWrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 3rem;
    max-width: 1100px;
    margin: 0 auto;
}

.cardsWrapper>* {
    flex: 0 0 280px;
    max-width: 280px;
}
</style>